import React from 'react'
import { useStyles } from './TemplateName.styles'
import clsx from 'clsx'
import { Typography } from '@mui/material'
import { TextInputV2 } from '@labrav/react-components'
import { useFormikContext } from 'formik'
import { ListingCardInCreation } from '../../../../modules/storefront/listingCardCreation/reducer'

export const TemplateName: React.FC = () => {
  const { classes } = useStyles()
  const { values, errors, touched, handleBlur, handleChange } =
    useFormikContext<ListingCardInCreation>()
  const { listingCardData } = values
  return (
    <div
      className={clsx(
        classes.root,
        classes.sectionWrapper,
        classes.cardHeadingWrapper,
        classes.content
      )}
    >
      <Typography
        className={classes.textHeading}
        data-testid="template-name-description"
      >
        Unique listing cards layout name
      </Typography>
      <TextInputV2
        keyName="listingCardData.name"
        title="Enter name"
        type="text"
        placeHolder=""
        updatedValue={listingCardData.name as string}
        value={listingCardData?.name as string}
        isError={
          !!(touched?.listingCardData?.name && errors?.listingCardData?.name)
        }
        onChange={handleChange}
        isReadOnly={false}
        isRequired={false}
        errorText={
          (!!touched?.listingCardData?.name && errors?.listingCardData?.name) ||
          ''
        }
        showSpinner={false}
        onBlur={handleBlur}
      />
    </div>
  )
}
